import {Link, Paper, Stack, styled, Typography} from "@mui/material";
import HeaderBreadcrumb from "../components/HeaderBreadcrumb";

const Section = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.admin.light,
    color: theme.palette.admin.contrastText,
}));

export const Title = styled(Typography)(({theme}) => ({
    padding: '0.5rem',
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
}));

export const HelpSection = styled(Stack)(() => ({
    padding: '0 0 0 1rem',
}));

export const HelpCaption = styled(Typography)(({theme}) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: 0,
    marginBottom: 0,
}));

export const HelpText = styled(Typography)(({theme}) => ({
    fontSize: theme.typography.body2.fontSize,
    paddingBottom: '0.5rem',
    "& dd": {
        display: 'list-item',
        listStyleType: 'disc',
        "& .sublist": {
            listStyleType: 'circle',
        },
    },
    "& dl": {
        marginTop: 0,
    }
}));

const Help = () => {
    return (
        <Stack>
            <HeaderBreadcrumb name="Help" color="admin"/>
            <Stack sx={{padding: '1rem'}} spacing={2}>
                <Paper variant="outlined" sx={{border: 'none'}}>
                    <Stack spacing={1}>
                        <Section elevation={0}>
                            <Title id="help_title" name="help_title">Help</Title>
                        </Section>
                        <HelpSection>
                            <HelpCaption>Helpful guides</HelpCaption>
                            <HelpText>
                                There are helpful guides in the glossary section in <Link href="/help/levels">Pay Levels</Link> and <Link href="/help/awards">Pay Awards</Link>. Select the Help button
                                in the top right-hand corner.
                            </HelpText>
                        </HelpSection>
                        <HelpSection>
                            <HelpCaption>Manage your password</HelpCaption>
                            <HelpText>
                                You can view your username and change your password in the <Link href="/my_details">My Details</Link> section in the top right-hand corner. To change your username,
                                please contact a member of the team on +44(0)1702 669549 or <Link href="mailto:sales@incomesdataresearch.com">email</Link> us.
                            </HelpText>
                        </HelpSection>
                        <HelpSection>
                            <HelpCaption>Support</HelpCaption>
                            <HelpText>
                                If you are having trouble logging on or require further technical support, please contact a member of the team on +44(0)1702 669549
                                or <Link href="mailto:sales@incomesdataresearch.com">email</Link> us. For urgent issues, please contact Louisa Withers on +44(0)7584 552178
                            </HelpText>
                        </HelpSection>
                        <HelpSection>
                            <HelpCaption>Contact us</HelpCaption>
                            <HelpText>
                                If you wish to provide us with your own pay review outcome or pay data, or to speak to a member of the research or sales team email: <Link
                                href="mailto:sales@incomesdataresearch.com">sales@incomesdataresearch.com</Link> To find out more about IDR services and products please
                                visit: <Link href="https://www.incomesdataresearch.co.uk" target="_blank" rel="noopener">www.incomesdataresearch.co.uk</Link>.
                            </HelpText>
                        </HelpSection>
                    </Stack>
                </Paper>
            </Stack>
        </Stack>
    );
};

export default Help;
